import { createFileRoute } from '@tanstack/react-router';
import { LessonPage } from '../../features/start/lesson-page.tsx';
import { lessonNoOf } from '../../features/start/lesson-no.ts';

// One lesson (T33b, spec J6.2). A lesson number that is not 1–99 shows "not found" without
// asking the API.
export const Route = createFileRoute('/_authed/start/lessons/$no')({
  component: LessonRoute,
});

function LessonRoute(): React.JSX.Element {
  const { no } = Route.useParams();
  const lessonNo = lessonNoOf(no);
  if (lessonNo === null) {
    return (
      <section className="page">
        <h1 className="page__title">Lesson not found</h1>
        <p role="alert">There is no lesson with that number.</p>
      </section>
    );
  }
  return <LessonPage key={lessonNo} no={lessonNo} />;
}
